import TennisInformation from './Tennis';

export { TennisInformation };
